<template>
  <v-layout>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>
            <TransactionFilters/>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Płatności
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn
                  class="mx-2"
                  @click="refresh"
              >
                Odśwież
              </v-btn>
            </div>
            <data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                class="row-pointer"
                @click:row="onRowClicked"
            >
              <template v-slot:top>
                <v-dialog v-model="dialogCancel" width="unset">
                  <v-card>
                    <v-card-title class="headline">
                      Czy na pewno chcesz anulować tę płatność?
                    </v-card-title>
                    <v-card-text>
                      ID: {{ editedText }}
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="onCancelDialogClosed">
                        Anuluj
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="onCancelConfirmed">
                        Tak
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.buyerId="{ item }">
                <router-link
                    v-if="item.buyerId"
                    :to="{name: 'user-details', params: {id: item.buyerId}}"
                >
                  #{{ item.buyerId }}
                </router-link>
              </template>
              <template v-slot:item.payU_orderId="{ item }">
                {{ item.payU_orderId }}
              </template>
              <template v-slot:item.quantity="{ item }">
                {{ item.quantity }}
              </template>
              <template v-slot:item.amount="{ item }">
                {{ formatAmount(item.amount) }} {{ item.currencyCode }}
              </template>
              <template v-slot:item.status="{ item }">
                <span :class="getTransactionStatusColor(item.status)">
                  {{ getTransactionStatusText(item.status) }}
                </span>
                <div v-if="isTransactionCancelled(item.status)">
                  <span v-if="item.statusChangedBy">Przez:</span>
                  <em v-if="'User' !== item.statusChangedBy">{{ item.statusChangedBy }}</em>
                  <router-link
                      v-if="item.statusChangedByUserId"
                      :to="{name: 'user-details', params: {id: item.statusChangedByUserId}}"
                  >
                    #{{ item.statusChangedByUserId }}
                  </router-link>
                </div>
              </template>
              <template v-slot:item.statusChangedAt="{ item }">
                {{ localDateTime(item.statusChangedAt, '') }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAt, '') }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ localDateTime(item.updatedAt, '') }}
              </template>
              <template v-slot:item.actions="{ item }"
                        class="text-end"
              >
                <v-icon
                    v-if="!isTransactionFinished(item.status || '')"
                    class="mx-2"
                    :disabled="loading"
                    @click="onCancelBtnTriggered(item, $event)"
                    title="Anuluj."
                >
                  mdi-cancel
                </v-icon>
              </template>
            </data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '@/services/api';
import DataTable from "@/components/data-table/DataTable";
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
import {
  getStatusColor as getTransactionStatusColor,
  getStatusText as getTransactionStatusText,
  isCancelled as isTransactionCancelled,
  isFinished as isTransactionFinished,
} from '@/enums/TransactionStatus';
import TransactionFilters from "@/components/transactions/TransactionFilters";

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    TransactionFilters,
    DataTable,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      options: {},
      headers: [
        {text: 'Kupujący', value: 'buyerId', sortable: false},
        {text: 'Nr zamówienia PayU', value: 'payU_orderId', sortable: false},
        {text: 'Kwota', value: 'amount', sortable: false},
        {text: 'Status', value: 'status', sortable: false},
        {text: 'Data zmiany statusu', value: 'statusChangedAt', sortable: false},
        {text: 'Utworzono', value: 'createdAt', sortable: false},
        {text: 'Ost. aktualizacja', value: 'updatedAt', sortable: false},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      filters: {},
      dialogCancel: false,
      editedIndex: -1,
      editedText: '',
      urlCancel: '/api/transaction/{id}',
    }
  },
  mounted() {
    const self = this;

    this.$root.$on('loadTransactions', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
    dialogCancel(value) {
      value || this.onCancelDialogClosed();
    },
  },
  methods: {
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendIntFilterIfNonEmpty(params, 'buyerId', filters.buyerId);
      this.appendStringFilterIfNonEmpty(params, 'payU_orderId', filters.payU_orderId);
      this.appendRangeFilterIfNonEmpty(
          params, 'quantity', filters.quantity, 1, 2147483647
      );
      this.appendRangeFilterIfNonEmpty(
          params, 'amount', filters.amount, 0, 2147483647
      );
      this.appendArrayFilterIfNonEmpty(params, 'statuses', filters.statuses);
    },
    cancelItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedText = item.id;
      this.dialogCancel = true;
    },
    formatEmpty(value, onEmptyHtml = 'Brak', onEmptyClasses = 'orange--text') {
      if (null !== value && '' !== value) {
        return value;
      }

      return `<em class="${onEmptyClasses}">${onEmptyHtml}</em>`;
    },
    cancel(index) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      const item = this.items[index];

      api
          .delete(this.urlCancel.replace('{id}', item.id))
          .then((response) => {
            const statuses = this.filters.statuses || [];

            if (statuses.length &&
                !statuses.includes('CANCELED') &&
                !statuses.includes('CANCELLED')
            ) {
              // The table is not displaying such statuses.
              this.items.splice(index, 1);
              this.total--;

              if (!this.items.length) {
                this.items.page--;
              }
            } else {
              item.status = response.data.status;
              item.statusChangedAt = response.data.statusChangedAt;
              item.cancelledByUserId = response.data.cancelledByUserId;
              item.updatedAt = response.data.updatedAt;
            }

            this.onCancelDialogClosed();

            if (this.isTransactionCancelled(item.status)) {
              this.$root.$emit('notifySuccess', {
                html: `Transakcja została anulowana.`,
              });
            } else {
              this.$root.$emit('notifyError', {
                html: `Nie udało się anulować transakcji - serwer obsłużył żądanie, ale nie zmienił statusu.`,
              });
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się anulować transakcji.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;
      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/transaction', {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy płatności.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    mapBool(value, onNull = false) {
      if (null === value) {
        return onNull;
      }

      return !!value;
    },
    refresh() {
      const self = this;
      this.$root.$emit('loadTransactions', {
        onSuccess: () => {
          self.$root.$emit('notify', {
            html: 'Lista płatności odświeżona.',
          });
        }
      });
    },
    stopRowClickPropagation(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();
    },
    onCancelBtnTriggered(item, event) {
      this.stopRowClickPropagation(event);
      this.cancelItem(item);
    },
    onCancelConfirmed() {
      this.cancel(this.editedIndex);
    },
    onCancelDialogClosed() {
      this.dialogCancel = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedText = '';
      });
    },
    onRowClicked(item) {
      this.$router
          .push({name: 'transaction-details', params: {id: item.id}})
          .catch(() => {
          })
    },
    getTransactionStatusColor(status) {
      return getTransactionStatusColor(status);
    },
    getTransactionStatusText(status) {
      return getTransactionStatusText(status);
    },
    isTransactionCancelled(status) {
      return isTransactionCancelled(status);
    },
    isTransactionFinished(status) {
      return isTransactionFinished(status);
    },
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>